import React from 'react';
import Tabs from '../../../common/components/Tabs';

export default (props) => <Tabs className="zedoc-tour__tabs" {...props} />;
